
import { FormFieldType } from '@/types/form';

export const useElementGroups = (isPage3: boolean, elements: FormFieldType[]) => {
  if (!isPage3) return null;

  const topicElements = elements.filter(el => 
    el.id === 'section_development_info' || 
    el.id === 'worksheet_search' || 
    el.id === 'topic_learned'
  );

  const knowledgeElements = elements.filter(el => 
    el.id === 'knowledge_rating' || el.id === 'knowledge_behavior'
  );

  const skillsElements = elements.filter(el => 
    el.id === 'skills_rating' || el.id === 'skills_behavior'
  );

  const attitudeElements = elements.filter(el => 
    el.id === 'attitude_rating' || el.id === 'attitude_behavior'
  );

  const otherElements = elements.filter(el => 
    !topicElements.includes(el) && 
    !knowledgeElements.includes(el) && 
    !skillsElements.includes(el) && 
    !attitudeElements.includes(el)
  );

  return {
    topicElements,
    knowledgeElements,
    skillsElements,
    attitudeElements,
    otherElements
  };
};
